export default {
  default: () => import("/Users/filipsuska/Work/bs-app/layouts/default.vue").then(m => m.default || m),
  raw: () => import("/Users/filipsuska/Work/bs-app/layouts/raw.vue").then(m => m.default || m)
}